module.exports = __webpack_public_path__ + "static/media/furniture-store.26803c09.jpg";